import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import TourPackageService from "../../services/tourpackage.service";

// **Async Thunks**
export const posttravelPackage = createAsyncThunk(
  "travelPackage/posttravelPackage",
  async (item, thunkAPI) => {
    try {
      const response = await TourPackageService.addtravelPackage(item);
      return response.data; // Return actual data
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const gettravelPackageList = createAsyncThunk(
  "travelPackage/gettravelPackageList",
  async (item, thunkApi) => {
    try {
      const response = await TourPackageService.gettravelPackageList(item);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const puttravelPackage = createAsyncThunk(
  "travelPackage/puttravelPackage",
  async (item, thunkAPI) => {
    try {
      const response = await TourPackageService.edittravelPackage(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deletetravelPackage = createAsyncThunk(
  "travelPackage/deletetravelPackage",
  async (id, thunkAPI) => {
    try {
      await TourPackageService.deletetravelPackage(id);
      return id; // Return only the ID to remove it from state
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// **Initial State**
const initialState = {
  loading: false,
  error: "",
  travelPackages: [],
};

// **Slice**
const travelPackageSlice = createSlice({
  name: "travelPackage",
  initialState,
  extraReducers: (builder) => {
    builder
      // **Handle Get Travel Package List**
      .addCase(gettravelPackageList.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(gettravelPackageList.fulfilled, (state, action) => {
        state.loading = false;
        state.travelPackages = action.payload;
      })
      .addCase(gettravelPackageList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Add Travel Package**
      .addCase(posttravelPackage.pending, (state) => {
        state.loading = true;
      })
      .addCase(posttravelPackage.fulfilled, (state, action) => {
        state.loading = false;
        state.travelPackages.push(action.payload);
      })
      .addCase(posttravelPackage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Edit Travel Package**
      .addCase(puttravelPackage.pending, (state) => {
        state.loading = true;
      })
      .addCase(puttravelPackage.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.travelPackages.findIndex((p) => p.id === action.payload.id);
        if (index !== -1) {
          state.travelPackages[index] = action.payload;
        }
      })
      .addCase(puttravelPackage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Delete Travel Package**
      .addCase(deletetravelPackage.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletetravelPackage.fulfilled, (state, action) => {
        state.loading = false;
        state.travelPackages = state.travelPackages.filter((p) => p.id !== action.payload);
      })
      .addCase(deletetravelPackage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// **Export Reducer**
export default travelPackageSlice.reducer;
